import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ActiveOrder } from "../../shared/interface/active-order";
import { OrderItem } from "../../shared/interface/order-item";

@Injectable({
  providedIn: 'root'
})
@Pipe({ name: 'filterOrderItemsForStatusDetailScreen' })
export class FilterOrderItemsForStatusDetailScreenPipe implements PipeTransform {

  transform(order: ActiveOrder): ActiveOrder {
    if (order.OrderItems.length > 0) {
      order.OrderItems = order.OrderItems.filter((orderItem: OrderItem) =>
        this.canSetOrderItemForOrderStatus(orderItem)
      );
    }
    return order;
  }

  canSetOrderItemForOrderStatus(orderItem, isAllItemDone = false) {
    return (orderItem.OrderProductComponents.length ? orderItem.OrderProductComponents[0].IsShowOnMakeTable : false) &&
      (orderItem.Price > 0) &&
      (orderItem.Qty - Math.abs(orderItem.RefundQty ? orderItem.RefundQty : 0)) > 0 &&
      (orderItem.ScheduleTime ? new Date(orderItem.ScheduleTime) <= new Date() : true);
  }
}
